module.exports = "//static.hsappstatic.net/ContentComponents/static-2.69719/img/website-page-zero.svg"